import { html, LitElement } from 'lit';

class TargetIcon extends LitElement {
  render() {
    return html`<svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_126_14)">
        <path
          d="M22 0C19.1109 0 16.2501 0.569047 13.581 1.67465C10.9118 2.78025 8.48654 4.40076 6.44365 6.44365C2.31785 10.5695 0 16.1652 0 22C0 27.8348 2.31785 33.4305 6.44365 37.5563C8.48654 39.5992 10.9118 41.2197 13.581 42.3254C16.2501 43.431 19.1109 44 22 44C27.8348 44 33.4305 41.6822 37.5563 37.5563C41.6822 33.4305 44 27.8348 44 22C44 19.448 43.538 16.918 42.658 14.542L39.138 18.062C39.446 19.36 39.6 20.68 39.6 22C39.6 26.6678 37.7457 31.1444 34.4451 34.4451C31.1444 37.7457 26.6678 39.6 22 39.6C17.3322 39.6 12.8556 37.7457 9.55492 34.4451C6.25428 31.1444 4.4 26.6678 4.4 22C4.4 17.3322 6.25428 12.8556 9.55492 9.55492C12.8556 6.25428 17.3322 4.4 22 4.4C23.32 4.4 24.64 4.554 25.938 4.862L29.48 1.32C27.082 0.462 24.552 0 22 0ZM37.4 0L28.6 8.8V12.1L22.99 17.71C22.66 17.6 22.33 17.6 22 17.6C20.833 17.6 19.7139 18.0636 18.8887 18.8887C18.0636 19.7139 17.6 20.833 17.6 22C17.6 23.167 18.0636 24.2861 18.8887 25.1113C19.7139 25.9364 20.833 26.4 22 26.4C23.167 26.4 24.2861 25.9364 25.1113 25.1113C25.9364 24.2861 26.4 23.167 26.4 22C26.4 21.67 26.4 21.34 26.29 21.01L31.9 15.4H35.2L44 6.6H37.4V0ZM22 8.8C18.4991 8.8 15.1417 10.1907 12.6662 12.6662C10.1907 15.1417 8.8 18.4991 8.8 22C8.8 25.5009 10.1907 28.8583 12.6662 31.3338C15.1417 33.8093 18.4991 35.2 22 35.2C25.5009 35.2 28.8583 33.8093 31.3338 31.3338C33.8093 28.8583 35.2 25.5009 35.2 22H30.8C30.8 24.3339 29.8729 26.5722 28.2225 28.2225C26.5722 29.8729 24.3339 30.8 22 30.8C19.6661 30.8 17.4278 29.8729 15.7775 28.2225C14.1271 26.5722 13.2 24.3339 13.2 22C13.2 19.6661 14.1271 17.4278 15.7775 15.7775C17.4278 14.1271 19.6661 13.2 22 13.2V8.8Z"
          fill="#E88F2A"
        />
      </g>
      <defs>
        <clipPath id="clip0_126_14">
          <rect width="44" height="44" fill="white" />
        </clipPath>
      </defs>
    </svg>`;
  }
}

customElements.define('target-icon', TargetIcon);
